import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { SVGThemableHover } from "../ReusableStyledComponents/ActiveFilterToggle";
import { AuthoryColorSchemeProps } from "../ReusableStyledComponents/FontSetUtilities";

export const PCFIconWrapper = styled.div<AuthoryColorSchemeProps & { $active?: boolean }>`
    position: relative;
    overflow: hidden;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        width: 33px;
    }

    ${SVGThemableHover}

    svg {
        opacity: ${({ $active }) => ($active ? 1 : undefined)};
    }

    select {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
`;
